module.exports = __webpack_public_path__ + "static/media/save_floppy.60cf6b54.svg";